



























































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
// import VueAnimateNumber from 'vue-animate-number';
import Tail from '@/layouts/tail.vue';
declare let scrollReveal: any;
import homeFooter from './component/footer.vue';
@Component({
  components: { Tail, homeFooter },
})
export default class Index extends Vue {
  private isActive = 0;
  private getActive = [1, 0, 0];

  private page = 1;
  private pageSize = 10;
  private templateHot: any = null;
  private voteCaseData: any = null;
  private voteCase: any = null;
  // public $refs: any;
  private popupShow: any = false;
  private popup11Show: any = false;
  private questionDataList: any = [];
  public mounted() {
    const str: any = '#homeTop';
    if (str) {
      document.querySelector(str);
    }
  }
  /**
   * 跳转到问卷管理页
   */
  private toUse() {
    let routesName = 'loginIndex';
    if (this.$store.getters['user/isLogin']()) {
      routesName = 'questionnairetemplateLibrarySurvey';
      this.$router.push({ name: routesName });
    } else {
      const { href } = this.$router.resolve({
        name: routesName,
      });
      window.open(href, '_blank');
    }
  }

  private turnTo(name: any) {
    this.$nextTick(() => {
      const element = document.getElementById(name);
      console.log(element);
      if (element) {
        // 判断是否IE浏览器  ,ie不支持scrollTo.behavior
        if (!!window.ActiveXObject || 'ActiveXObject' in window) {
          window.scrollTo(0, element.offsetTop - 75);
        } else {
          window.scrollTo({
            top: element.offsetTop - 75,
            behavior: 'smooth',
          });
        }
      }
    });
  }
  private created() {
    // var parmas = this.$tool.encrypt("256");
    // console.log("AES加密", parmas);
    // parmas = this.$tool.decrypt(parmas);
    // console.log("AES解密", parmas);
    // 活动案例
    this.getVoteCaseList();
    this.popupInit(); // 优惠弹窗
    this.getWxQuestionTemplateList();
  }
  /**
   *  获取问卷模板
   */
  private async getWxQuestionTemplateList() {
    for (let i = 1; i <= 5; i++) {
      const questionTemplateData = await this.$apis.getWxQuestionTemplateList({
        page: 1,
        pageSize: 8,
        templateProductType: i,
      });

      this.questionDataList.push(questionTemplateData.data);
    }
    // console.log(this.questionDataList, "questionTemplateData");
  }

  /**
   * 注册
   */
  private goLogin() {
    let routesName = 'loginIndex';
    if (this.$store.getters['user/isLogin']()) {
      routesName = 'votingList';
      // this.$router.push("/voting/list");
      // } else {
      // this.$router.push("/login");
    }
    const { href } = this.$router.resolve({
      name: routesName,
    });
    window.open(href, '_blank');
  }
  /**
   * 跳转投票评选
   */
  private goVoting() {
    let routesName = 'loginIndex';
    if (this.$store.getters['user/isLogin']()) {
      routesName = 'votingList';
    }
    const { href } = this.$router.resolve({
      name: routesName,
    });
    window.open(href, '_blank');
  }
  /**
   * 跳转问卷调研
   */
  private goQuestionnaire() {
    const routesName = 'loginIndex';
    if (this.$store.getters['user/isLogin']()) {
      this.$router.push('/questionnaire/list.html');
      // this.$message({
      //   message: "即将上线",
      //   type: "success",
      // });
    } else {
      const { href } = this.$router.resolve({
        name: routesName,
      });
      window.open(href, '_blank');
    }
  }

  /**
   * 经典案例
   */
  private async getVoteCaseList() {
    this.pageSize = 10;
    this.voteCaseData = await this.$apis.getVoteCaseList({
      isCase: 1,
      page: this.page,
      pageSize: this.pageSize,
    });
    this.voteCase = this.voteCaseData.data;
  }

  /**
   * 更多模板
   */
  private getMoreTemplate() {
    const routesName = 'loginIndex';
    if (this.$store.getters['user/isLogin']()) {
      this.$router.push({
        path: '/template/list.html',
        query: {
          templateOrCase: '0',
        },
      });
    } else {
      const { href } = this.$router.resolve({
        name: routesName,
      });
      window.open(href, '_blank');
    }
  }
  /**
   * 更多案例
   */
  // private getToCreat() {
  //   const routesName = "loginIndex";
  //   if (this.$store.getters["user/isLogin"]()) {
  //     this.$router.push({
  //       path: "/questionnaire/list.html",
  //     });
  //   } else {
  //     const { href } = this.$router.resolve({
  //       name: routesName,
  //     });
  //     window.open(href, "_blank");
  //   }
  // }
  /**
   * 跳转问卷模板
   */
  private toQuestionTemplate(id: any) {
    // console.log("跳转");
    this.$router.push({
      path: '/template/list.html',
      query: {
        templateType: id,
      },
    });
  }

  /**
   * 取第一张图片
   */
  private getImage(imgUrl: any) {
    if (imgUrl != null) {
      const bannerArr = imgUrl.split(',');
      return bannerArr[0];
    }
    return null;
  }
  /**
   * 跳转活动详情
   */
  private getVoteDetail(item: any, caseType: any) {
    let voteId = item.voteId;
    if (voteId) {
      voteId = this.$tool.encrypt(item.voteId);
    }
    const { href } = this.$router.resolve({
      name: 'voteDetail',
      query: {
        voteId,
        caseType,
      },
    });
    window.open(href, '_blank');
  }
  /**
   * 跳转问卷详情
   */
  private getQuestionDetail(item: any, caseType: any) {
    let questionId = item.questionId;
    if (questionId) {
      questionId = this.$tool.encrypt(item.questionId);
    }
    const { href } = this.$router.resolve({
      name: 'questionDetail',
      query: {
        questionId,
        caseType,
      },
    });
    window.open(href, '_blank');
  }
  private backTop() {
    const str: any = '#homeTop';
    if (str) {
      document.querySelector(str).scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  private prev() {
    const el: any = this.$refs.chart;
    el.prev();
  }
  private next() {
    const el: any = this.$refs.chart;
    el.next();
  }
  private popupInit() {
    setTimeout(() => {
      this.popupShow = true;
    }, 8000);
  }
  private closePopup() {
    this.popupShow = false;
    // this.popup11Init();
  }
  private close11Popup() {
    this.popup11Show = false;
  }
  private popup11Init() {
    setTimeout(() => {
      this.popup11Show = true;
    }, 3000);
  }
  private open11Popup() {
    this.goLogin();
    // this.popupShow = false;
    // this.popup11Show = true;
  }
}
